import React, { memo } from "react";

import { FilterByApplication } from "../../../../components/Filters/FilterByApplication";
import type { IApplication } from "../../../../hooks/reactQueryHooks/useApplications";
import { OverviewDateFilter } from "./OverviewDateFilter";
interface IProps {
  applications: Array<IApplication>;
  appQuery: string | null;
}

const Filters: React.FC<IProps> = memo(({ applications }) => {
  return (
    <div className="overview-filters" data-testid="overview-filters">
      <div className="overview-filters__app">
        <FilterByApplication applications={applications} />
      </div>
      <div className="overview-filters__date">
        <OverviewDateFilter />
      </div>
    </div>
  );
});

export { Filters };
